import { createAction } from 'redux-actions';
export const checkout_update_form = createAction('CHECKOUT_UPDATE_FORM');
export const checkout_update_login = createAction('CHECKOUT_UDPATE_LOGIN');
export const checkout_reset = createAction('CHECKOUT_RESET');